import chevronLeftSvg from "../assets/icon-chevron-left.svg";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ currentPage, totalPages, onPageChange }: Readonly<PaginationProps>) {
  if (totalPages <= 1) return null;

  const pages = buildPageNumbers(currentPage, totalPages);
  const pageEntries = pages.map((page, i) => ({
    page,
    key: page === "..." ? `ellipsis-${i}` : String(page),
  }));

  return (
    <div className="flex gap-1 items-center">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="size-7 flex items-center justify-center rounded border border-stroke-primary disabled:opacity-30"
        aria-label="Previous page"
      >
        <img src={chevronLeftSvg} alt="" width={22} height={22} />
      </button>
      {pageEntries.map(({ page, key }) =>
        page === "..." ? (
          <span key={key} className="size-7 flex items-center justify-center text-sm text-text-primary">
            ...
          </span>
        ) : (
          <button
            key={key}
            onClick={() => onPageChange(page)}
            className={`size-7 flex items-center justify-center rounded border border-stroke-primary text-sm font-medium text-text-primary ${
              page === currentPage ? "bg-bg-secondary" : ""
            }`}
            aria-current={page === currentPage ? "page" : undefined}
          >
            {page}
          </button>
        ),
      )}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="size-7 flex items-center justify-center rounded border border-stroke-primary disabled:opacity-30 rotate-180"
        aria-label="Next page"
      >
        <img src={chevronLeftSvg} alt="" width={22} height={22} />
      </button>
    </div>
  );
}

function buildPageNumbers(current: number, total: number): (number | "...")[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | "...")[] = [1];
  if (current > 3) pages.push("...");
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);
  if (current < total - 2) pages.push("...");
  pages.push(total);
  return pages;
}
